import Resource from '@/api/resources/Resource'

class DiagnosisPortionService extends Resource {
    async createPortionRevision(laboratoryId, caseId, sampleId, portionId, request) {
        const response = await this.axios.post(`/diagnosis/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}/revisions`, request)
        return response.data
    }
    async getSamplePortions(laboratoryId, caseId, sampleId) {
        const response = await this.axios.get(`/diagnosis/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/portions`)
        return response.data
    }
}

export default new DiagnosisPortionService()
